import { Injectable } from '@angular/core'
import { APIService } from '../services/api.service'
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
@Injectable()
export class CouponService {

    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        })
    }
    constructor(private _http: HttpClient, private _apiServices: APIService) { }

    // Method for get employee list

    getcoupans(): Observable<any> {
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "userid": loginUser.userDetail.id,
            "token": loginUser.token,
            "isForAdmin": true

        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/getoffers", body, this.httpOptions)
            .catch(this.handleError);

    }


    // Method for Save new Coupon details
    saveCoupon(couponForm) {

        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');

        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = couponForm;
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/saveCoupon", body, this.httpOptions)
            .catch(this.handleError);
    }

    // Method for Save new Coupon details
    publishCoupon(coupon) {
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = { "isPublished": coupon.isCouponsActive, "token": loginUser.token, "id": coupon.couponId }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/updateCouponStatus", body, this.httpOptions)
            .catch(this.handleError);
    }

    // Method for Delete coupons
    deleteCoupon(coupon) {
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = { "isdeleted": coupon.isCouponsActive, "token": loginUser.token, "id": coupon.couponId }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/deleteCoupon", body, this.httpOptions)
            .catch(this.handleError);
    }



    getPatientsCouponsList(selectedCouponid): Observable<any> {
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "userid": loginUser.userDetail.id,
            "token": loginUser.token,
            "couponid": selectedCouponid
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/getPatientsCouponList", body, this.httpOptions)
            .catch(this.handleError);

    }

    // Method for Assign new Coupon details
    assignCoupon(couponForm, selectedCouponid) {
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        var isActive = couponForm.IsSlotAssign == true ? false : true;
        let data = { "couponid": selectedCouponid, "userid": couponForm.Id, "isactive": isActive, "token": loginUser.token }

        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/assignUserCoupon", body, this.httpOptions)
            .catch(this.handleError);
    }


    generateHTML() {
        this.httpOptions.headers.append('Content-Type', 'application/json');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));

        let data = { "token": loginUser.token }
        let body = JSON.stringify(data);
        // return this._http.post(environment.apiURL + "/api/helloworld", body, {
        //     responseType: 'blob', headers: {
        //         Accept: 'text/plain'
        //     }
        // })
        return this._http.post(environment.apiURL + "/api/helloworld", body, this.httpOptions)
            .catch(this.handleError);
    }


    handleError(error: Response) {
        console.log(error);
        return Observable.throw(error);
    }

   // bulk upload coupons
    fileUploadService(formData) {
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        //this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        return this._http.post(environment.apiURL + "/api/uploadCouponCsv", formData)
            .catch(this.handleError);

    }

//http options alt
    // const httpOptions = {
    //     headers: new HttpHeaders({
    //         'Content-Type': 'application/json',
    //         'Access-Control-Allow-Origin': '*'
    //     })
    // }


    // fileUploadService(form) {
    //     this.httpOptions.headers.append('Content-Type', 'application/form-data');
    //     this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
    //     return this._http.post(environment.apiURL + "/api/importPatient", form)
    //         .catch(this.handleError);
    // }
}


// WEBPACK FOOTER //
// ./src/app/services/coupon.service.ts